import { useIsAuthenticated } from "@azure/msal-react";
import {
  publishScenario,
  ScenarioModel,
  unpublishScenario,
  Visibility,
} from "../../clients/BackOfficeApi";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { Flex } from "@chakra-ui/react";
import { useCallback } from "react";
import { ActionButton } from "../../elements/ActionButton";

interface Props {
  scenario: ScenarioModel;
  forCell?: boolean;
  onChange?: () => void;
}
export function ScenarioActions({
  scenario,
  forCell = false,
  onChange = () => {},
}: Props) {
  const isAuthenticated = useIsAuthenticated();

  const buttonVariant = forCell ? "link" : "solid";
  const direction = forCell ? "column" : "row";

  const publish = useCallback(
    (scenarioId: number) => {
      if (!isAuthenticated) return;

      publishScenario({
        path: { scenarioId },
        throwOnError: true,
      })
        .catch((e) => {
          console.error("Failed to publish scenario", e);
        })
        .finally(() => {
          onChange();
        });
    },
    [isAuthenticated, onChange]
  );

  const depublish = useCallback(
    (scenarioId: number) => {
      if (!isAuthenticated) return;

      unpublishScenario({
        path: { scenarioId },
        throwOnError: true,
      })
        .catch(() => {})
        .finally(onChange);
    },
    [isAuthenticated, onChange]
  );

  return (
    <Flex direction={direction} gap={2} minW={24}>
      {scenario.visibility === Visibility.UNPUBLISHED && (
        <ActionButton
          color="green.500"
          icon={<ViewIcon />}
          onClick={() => publish(scenario.id)}
          title="Publiceren"
          variant={buttonVariant}
        />
      )}
      {scenario.visibility === Visibility.PUBLISHED && (
        <ActionButton
          color="blue.500"
          icon={<ViewOffIcon />}
          onClick={() => depublish(scenario.id)}
          title="Depubliceren"
          variant={buttonVariant}
        />
      )}
    </Flex>
  );
}
